export const LEAD_OWNER_MODEL = 'Lead';
